import '../app.css';
import { maybeInitSentry } from '../sentry';

export const prerender = true;

maybeInitSentry();
